import React, { ReactElement } from "react";
import { ThemeProvider } from "@evergis/ui";
import { PieChartData } from "@evergis/charts";

import { ChartTooltip, ChartTooltipColor } from "../styled";
import { formatChartRelatedValue } from "./formatChartRelatedValue";
import { LayerInfo } from "../../../interfaces/resourceInfo";
import { ConfigRelatedDataSource } from "../types";

export const pieChartTooltipFromRelatedFeatures = (
  data: PieChartData[],
  relatedAttributes: ConfigRelatedDataSource[],
  layerInfo: LayerInfo,
): ReactElement | string => {
  if (!data?.length) return "";

  return (
    <ThemeProvider>
      <ChartTooltip>
        <ChartTooltipColor $color={data[0].color} />
        <div>
          {data[0].name} &nbsp; {formatChartRelatedValue(data[0].value, layerInfo, relatedAttributes)}
        </div>
      </ChartTooltip>
    </ThemeProvider>
  );
};
